package devxertech.com.pages.industries.healthCare

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import devxertech.com.seo.PageMetadataForCurrentRoute
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.pages.commons.CommonArrow
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.commons.MakeYourOwnTeam
import devxertech.com.pages.industries.healthCare.healthCareExp.HealthCareExpertise
import devxertech.com.pages.industries.healthCare.healthSpotLight.HealthSpotLight
import devxertech.com.pages.industries.healthCare.smartHealthCare.SmartHealthCare
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res

@Page("/healthcare-system")
@Composable
fun HealthCareSystem() {
    PageMetadataForCurrentRoute()
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()


    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
        CommonHeader(
            mainHeadingAsH1 = true,
            image =   Res.Image.health_header,
            imageAlt = "Healthcare software solutions",
            breakpoint = breakpoint,
            headingText = "Healthcare Software Development Services",
            descriptionText = "Smart, Enhanced & custom-built healthcare software solutions"
        )
        CommonArrow("HealthCare")
        HealthCareExpertise()
        SmartHealthCare(breakpoint, sitePalette)
        MakeYourOwnTeam(breakpoint)
        HealthSpotLight()
        RatingSection(breakpoint)
        HomepageFooter(breakpoint)

    }
}
